import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage3";
import React, { FC, useState, useEffect } from "react";
//import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
//import { getAllPackages } from "services/apiServices";
import { TaxonomyType } from "data/types";
//import Pagination from "shared/Pagination/Pagination";
import Heading3 from "components/Heading/Heading3";
import war from "./FilmImages/war.jpg";
import oop from "./FilmImages/oop.jpg";
import rou from "./FilmImages/rou.jpg";
import tho from "./FilmImages/tho.jpg";
import rab from "./FilmImages/rab.jpg";
import abb from "./FilmImages/abb.jpg";
import vas from "./FilmImages/vas.jpg";
import yam from "./FilmImages/yam.jpg";
import FlimHero from "./FlimHero";
import SectionSubHero from "components/SectionSubHero";
import { Star, Film } from 'lucide-react';

export interface ListingStayPageProps {
  className?: string;
}
const DEMO_CATS: TaxonomyType[] = [
  {
    id: "1",
    href: "/listing-stay",
    name: "WAR",
    taxonomy: "category",
    thumbnail: war,
  },
  {
    id: "222",
    href: "/listing-stay",
    name: "THOZHA",
    taxonomy: "category",
    thumbnail: tho,
  },
  {
    id: "3",
    href: "/listing-stay",
    name: "OOPIRI",
    taxonomy: "category",
    thumbnail: oop,
  },
  {
    id: "4",
    href: "/listing-stay",
    name: "RABHASA",
    taxonomy: "category",
    thumbnail: rab,
  },

  {
    id: "222",
    href: "/listing-stay",
    name: "ABBAYITHU AMMAYI",
    taxonomy: "category",
    thumbnail: abb,
  },
  {
    id: "3",
    href: "/listing-stay",
    name: "VASTUPRAKARA",
    taxonomy: "category",
    thumbnail: vas,
  },
  {
    id: "4",
    href: "/listing-stay",
    name: "YAMALEELA II",
    taxonomy: "category",
    thumbnail: yam,
  },
  {
    id: "5",
    href: "/listing-stay",
    name: "ROUGH",
    taxonomy: "category",
    thumbnail: rou,
  },
];

const ListingTourPage: FC<ListingStayPageProps> = ({ className = "" }) => {
  /*  const [packages, setPackages] = useState<any>([]);
   console.log('........................packages',packages)
 
   const getPackageData = async () => {
     const response = await getAllPackages()
     if (response.data) {
       let tempData: any = [];
       if (response.data.response === "success") {
         response.data.packages.map((item: any, key: number) => {
           tempData[key] = {
             id: item.id,
             href: "#",
             name: item.name,
             country: item.country,
             days: item.days,
             image:item.image,
             description: item.description,
             taxonomy: "category",
             count: 188288,
           }
         })
         setPackages(tempData)
       }
 
     }
   }
   useEffect(() => {
     getPackageData()
   }, []) */
  return (
    <div
      className={`nc-ListingStayPage relative overflow-hidden ${className}`}
      data-nc-id="ListingStayPage"
    >
      <BgGlassmorphism />

      <SectionSubHero
        title="Film Productions"
        pillTitle="Film Support"
        bgClass="dashboard-film-bg"
        description="Comprehensive production support in Europe, including locations, logistics, permits, and on-ground arrangements."
        className="pl-6 pt-10 lg:pt-10 lg:pb-10 mb-16"
      />

      <div className="container relative overflow-hidden">
        {/* SECTION */}
        <div
          className={`nc-SectionGridFilterCard mt-24 mb-24 lg:space-y-28 lg:mb-28 ${className}`}
          data-nc-id="SectionGridFilterCard"
        >
          <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
            {DEMO_CATS.map((film) => (
              <div
                key={film.id}
                className="nc-FilmCard group relative border border-gray-200 rounded-xl overflow-hidden bg-white shadow-md transition-all duration-300 hover:border-amber-500/50 hover:shadow-xl hover:shadow-amber-100"
                data-nc-id="FilmCard"
              >
                {/* Image Container with Overlay */}
                <div className="relative w-full overflow-hidden">
                  <div className="aspect-w-16 aspect-h-9 h-56 bg-gray-100">
                    <img
                      src={film.thumbnail || "/placeholder.svg"}
                      alt={film.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-20"></div>
                  </div>

                  <div className="absolute top-3 left-3 flex items-center gap-1 px-3 py-1 bg-blue-500/90 rounded-full border border-blue-400/30">
                    <Film className="w-3.5 h-3.5 text-white" />
                    <span className="text-xs font-semibold text-white">Film</span>
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-6 space-y-4">
                  <div className="space-y-2">
                    <h2 className="font-bold text-lg text-gray-900 line-clamp-2 leading-tight hover:text-amber-600 transition-colors">
                      {film.name}
                    </h2>
                  </div>

                  {/* <div className="flex items-center gap-2 py-3 border-t border-b border-gray-200">
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`w-4 h-4 ${
                            i < Math.round(4)
                              ? "fill-amber-500 text-amber-500"
                              : "text-gray-300"
                          }`}
                        />
                      ))}
                    </div>
                    <span className="text-xs text-gray-500">(4.0)</span>
                  </div> */}

                  {/* <button
                    className="w-full py-2.5 px-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold rounded-lg transition-all duration-300 hover:shadow-lg active:scale-95"
                  >
                    View Production
                  </button> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListingTourPage;
